<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import { addAvatar, removeAvatar } from '@/scripts/api/account';
import { updateUser, setSaveState } from '@/scripts/methods';
import { DEFAULT_AVATAR } from '@/scripts/constants/constants';
import { getAvatar } from '@/scripts/utils';
import { getFormData } from '@/scripts/utils/payload';
import { wsConnection } from '@/scripts/modules/ws';

export default {
  name: 'Avatar',
  components: {
    // CustomComponent,
  },
  props: {
    editable: {
      type: Boolean,
      default: !false,
    },
  },
  data() {
    return {
      saveState: null,
    };
  },
  computed: {
    ...mapState(['user']),
    avatar() {
      const { user, editable } = this;
      const url = getAvatar(user.avatar);

      const result = url
        ? `url(${url})`
        : editable
        ? null
        : `url(${DEFAULT_AVATAR})`;

      return result;
    },
    avatarProcessing() {
      const { user, saveState } = this;
      const result = !!((user && user.avatarProcessing) || saveState);

      return result;
    },
  },
  created() {
    /* ws */
    wsConnection.setCallback('avatar.update', this.updateUser);
  },
  mounted() {},
  destroyed() {
    wsConnection.removeCallback('avatar.update');
  },
  methods: {
    ...mapActions({}),
    removeAvatar() {
      removeAvatar().then(this.updateUser);
    },
    onFilePicked(event) {
      const [file] = event.target.files;

      if (!file) return;

      const FD = getFormData(file);

      this.setSaveState('saving');

      addAvatar(FD).then(() => {
        this.setSaveState();
        this.updateUser();
      });
    },
    updateUser,
    setSaveState,
  },
};
</script>

<template>
  <div class="avatar">
    <div
      :class="{
        'avatar__img-wrapper': true,
        'remove-avatar': avatar && editable,
      }"
    >
      <!-- avatar -->
      <div
        :class="{ avatar__img: true, default: false }"
        :style="[{ 'background-image': avatar }]"
      ></div>

      <!-- remove -->
      <div
        class="avatar__remove-avatar"
        v-if="avatar && editable"
        @click="removeAvatar"
      >
        <div class="avatar__remove-img">
          <img :src="require('@/assets/svg/delete.svg')" />
        </div>
        <div class="avatar__remove-title">DELETE IMAGE</div>
      </div>

      <!-- add -->
      <div class="avatar__upload" v-if="!avatar && !avatarProcessing">
        <div class="upload-avatar">
          <input
            type="file"
            accept="image/x-png,image/jpeg"
            @change="onFilePicked"
          />
          <div class="upload-avatar__content">
            <div class="upload-avatar__img">
              <img
                :src="require('@/assets/svg/upload-avatar/upload-photo.svg')"
              />
            </div>
            <div class="upload-avatar__title">UPLOAD IMAGE</div>
          </div>
        </div>
      </div>

      <!-- Processing -->
      <div class="avatar__processing" v-else-if="editable && avatarProcessing">
        <div class="processing">
          <div class="processing__img">
            <img :src="require('@/assets/svg/refresh.svg')" />
          </div>
        </div>
      </div>
    </div>

    <!-- mobile  -->
    <div class="avatar__delete" v-if="avatar && editable" @click="removeAvatar">
      Delete image
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.avatar {
  position: relative;
  width: 100%;
  height: 100%;

  &__img-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    position: relative;

    &.remove-avatar {
      cursor: pointer;

      &:hover {
        .avatar__remove-avatar {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

  &__upload,
  &__processing {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    background-color: rgba(16, 18, 18, 0.5);
    flex-shrink: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &__remove-avatar {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background-color: rgba(29, 36, 41, 0.8);
    padding: 27px 10px 23px;
    transition: all 0.2s;
  }

  &__remove-img {
    display: flex;
    justify-content: center;
    width: 21px;
    height: 24px;
    margin-bottom: 5px;

    img {
      display: flex;
      width: 21px;
      height: 24px;
    }
  }

  &__remove-title {
    font-family: Poppins-Regular;
    font-size: 8px;
    line-height: 11px;
    color: #ffffff;
    text-align: center;
  }

  &__delete {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
    color: #e93c5c;
    text-decoration: underline;
    display: none;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 100%;
    margin-left: 15px;
    transition: all 0.2s;
    cursor: pointer;
  }
}

.upload-avatar {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: rgba(48, 48, 48, 0.5);
  position: relative;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: rgba(48, 48, 48, 0.9);
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    padding: 27px 10px 20px;
  }

  &__img {
    display: flex;
    justify-content: center;
    width: 24px;
    height: 25px;
    margin-bottom: 5px;

    img {
      display: flex;
      width: 24px;
      height: 25px;
    }
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 8px;
    line-height: 11px;
    color: #ffffff;
    text-align: center;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}

.processing {
  border-radius: 12px;
  background-color: rgba(29, 36, 41, 0.8);
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__img {
    width: 20px;
    height: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    animation-name: spin;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/* mobile */
@media (max-width: $mobile) {
  .avatar__delete {
    display: flex;
  }

  .avatar__remove-avatar {
    display: none;
  }
}
</style>
